(function () {
  var PREFIX = "whatsapp_tracking";

  var GCLID_KEY = PREFIX + "_gclid";
  var GBRAID_KEY = PREFIX + "_gbraid";
  var WBRAID_KEY = PREFIX + "_wbraid";
  var TOKEN_KEY = PREFIX + "_token";

  function getStored(key) {
    try {
      return localStorage.getItem(key) || "";
    } catch (e) {
      return "";
    }
  }

  function setStored(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function generateToken(length) {
    var chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

    var values = new Uint32Array(length);

    crypto.getRandomValues(values);

    var token = "";

    for (var i = 0; i < length; i++) {
      token += chars[values[i] % chars.length];
    }

    return token;
  }

  function getToken() {
    var token = getStored(TOKEN_KEY);

    if (!token) {
      token = generateToken(6);
      setStored(TOKEN_KEY, token);
    }

    return token;
  }

  function getIdentifiers() {
    var params =
      new URLSearchParams(window.location.search);

    var gclid =
      params.get("gclid") || "";

    var gbraid =
      params.get("gbraid") || "";

    var wbraid =
      params.get("wbraid") || "";

    if (gclid) {
      setStored(GCLID_KEY, gclid);
    }

    if (gbraid) {
      setStored(GBRAID_KEY, gbraid);
    }

    if (wbraid) {
      setStored(WBRAID_KEY, wbraid);
    }

    return {
      gclid:
        gclid || getStored(GCLID_KEY),

      gbraid:
        gbraid || getStored(GBRAID_KEY),

      wbraid:
        wbraid || getStored(WBRAID_KEY),
    };
  }

  function saveTracking(token, identifiers) {
    return fetch("/apps/shefinity", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        token: token,
        gclid: identifiers.gclid || "",
        gbraid: identifiers.gbraid || "",
        wbraid: identifiers.wbraid || "",
        landing_page: window.location.pathname,
        page_url: window.location.href,
      }),

      keepalive: true,
    });
  }

  function prepareWhatsappUrl(link, token) {
    var url = new URL(link.href);

    var trackingText = [
      "مرحباً، لقد وجدت منتج على موقعكم وأرغب بالطلب او الاستفسار",
      "يرجى عدم مسح المُعرّف في الأسفل.",
      "ref: " + token,
    ].join("\n\n");

    url.searchParams.set(
      "text",
      trackingText,
    );

    return url.toString();
  }

  function init() {
    /*
     * Important:
     * read/save GCLID immediately when page loads.
     */
    var token = getToken();
    var identifiers = getIdentifiers();

    console.log(
      "WhatsApp tracking initialized:",
      {
        token: token,
        gclid: identifiers.gclid,
        gbraid: identifiers.gbraid,
        wbraid: identifiers.wbraid,
      },
    );

    /*
     * Update currently existing WhatsApp links.
     */
    document
      .querySelectorAll(
        'a[href*="wa.me"], a[href*="whatsapp.com"]',
      )
      .forEach(function (link) {
        link.href =
          prepareWhatsappUrl(
            link,
            token,
          );
      });

    /*
     * Global listener:
     * also works for WhatsApp buttons
     * created later by Shopify/theme/apps.
     */
    document.addEventListener(
      "click",
      function (event) {
        var target = event.target;

        if (!(target instanceof Element)) {
          return;
        }

        var link = target.closest(
          'a[href*="wa.me"], a[href*="whatsapp.com"]',
        );

        if (!link) {
          return;
        }

        event.preventDefault();

        /*
         * Read again at click time in case
         * identifiers changed after init.
         */
        var currentToken = getToken();
        var currentIdentifiers =
          getIdentifiers();

        var whatsappUrl =
          prepareWhatsappUrl(
            link,
            currentToken,
          );

        console.log(
          "WhatsApp click:",
          {
            token: currentToken,
            gclid:
              currentIdentifiers.gclid,
            gbraid:
              currentIdentifiers.gbraid,
            wbraid:
              currentIdentifiers.wbraid,
          },
        );

        saveTracking(
          currentToken,
          currentIdentifiers,
        )
          .then(function (response) {
            console.log(
              "Tracking status:",
              response.status,
            );

            return response.text();
          })
          .then(function (text) {
            console.log(
              "Tracking response:",
              text,
            );
          })
          .catch(function (error) {
            console.error(
              "Tracking error:",
              error,
            );
          })
          .finally(function () {
            window.location.href =
              whatsappUrl;
          });
      },
      true,
    );
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
    );
  } else {
    init();
  }
})();